import { EditionContractType } from '../../types'
import Decent1155MintStrategy from './Decent1155MintStrategy'
import Decent721MintStrategy from './Decent721MintStrategy'
import {
  IArgDict,
  IEditionMintStrategy,
  IPrivateMintFunctionArgs,
  IPublicMintFunctionArgs
} from './IEditionMintStrategy'
import Kits721MintStrategy from './Kits721MintStrategy'

class EditionMintStrategy {
  private strategy: IEditionMintStrategy

  constructor(editionContractType: EditionContractType) {
    if (editionContractType == EditionContractType.KITS_721) {
      this.strategy = Kits721MintStrategy
    } else if (editionContractType == EditionContractType.DECENT_721) {
      this.strategy = Decent721MintStrategy
    } else if (editionContractType == EditionContractType.DECENT_1155) {
      this.strategy = Decent1155MintStrategy
    } else {
      throw new Error('Invalid edition creator type')
    }
  }

  getAbi() {
    return this.strategy.getAbi()
  }

  getPublicMintFunctionName(): string {
    return this.strategy.getPublicMintFunctionName()
  }

  getPublicMintFunctionArgsDict({
    currentWalletAddress,
    mintCount
  }: IPublicMintFunctionArgs): IArgDict[] {
    return this.strategy.getPublicMintFunctionArgsDict({
      currentWalletAddress,
      mintCount
    })
  }

  getPublicMintFunctionArgs(input: IPublicMintFunctionArgs): any[] {
    return this.getPublicMintFunctionArgsDict(input).map((item) => item.value)
  }

  getPresaleMintFunctionName(): string {
    return this.strategy.getPresaleMintFunctionName()
  }

  getPresaleMintFunctionArgsDicts({
    currentWalletAddress,
    mintCount,
    maxPurchasablePerWallet,
    preSalePrice,
    merkleProof
  }: IPrivateMintFunctionArgs): IArgDict[] {
    return this.strategy.getPresaleMintFunctionArgsDicts({
      currentWalletAddress,
      mintCount,
      maxPurchasablePerWallet,
      preSalePrice,
      merkleProof
    })
  }

  /**
   * Returns the args for the public sale mint function as an array.
   */
  getPresaleMintFunctionArgs(input: IPrivateMintFunctionArgs): any[] {
    return this.strategy.getPresaleMintFunctionArgsDicts(input).map((item) => item.value)
  }

  getMintTotalFunctionName(): string {
    return this.strategy.getMintTotalFunctionName()
  }

  getMintTotalArgs(): any[] | undefined {
    return this.strategy.getMintTotalArgs()
  }

  getMintTotalsFromData(data: any): { totalMinted: number; presaleMinted: number } {
    return this.strategy.getMintTotalsFromData(data)
  }
}

export default EditionMintStrategy
